import Vue from 'vue'
import Router from 'vue-router'
import WtContainer from '@/components/WtLayout/WtContainer'
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
const staticRoutes = [
  {
    isStatic: true,
    path: '/static',
    component: WtContainer,
    name: '菜单示例',
    meta: { title: '菜单示例', icon: '' },
    hidden: true,
    children: [
    // {
    //   name: 'static2',
    //   meta: { title: '数据列表-自定义', icon: '' },
    //   component: () => import('@/modules/auth/test/test2.vue'),
    //   path: 'static2'
    // }
    ]
  }
]

/*  插件 静态 ROUTER 开始 */
const plugins = require.context('@/plugins', true, /router\/staticRoutes\.js$/)
plugins.keys().forEach(key => {
  const obj = plugins(key).default
  if (obj.length > 0) {
    obj.forEach((item) => {
      staticRoutes.push(item)
    })
  }
})
/*  插件 静态 ROUTER 结束 */

export default staticRoutes
